import { gt } from 'ramda'

// returns true if input number is greater than 1

const isMany = gt(1)

export default isMany